import { Link } from 'react-router-dom'
import styledComponents from 'styled-components'

export const InsertButton = styledComponents(Link).attrs({
  className: 'btn btn-info',
})`
`
